import { useEffect, useState } from 'react';
import { APP } from '../tokens';

const F = APP.fontFamily;

interface ReviewUndoToastProps {
  sectionRef: string;
  action: 'accepted' | 'dismissed';
  onUndo: () => void;
}

export default function ReviewUndoToast({ sectionRef, action, onUndo }: ReviewUndoToastProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Trigger enter animation
    requestAnimationFrame(() => setVisible(true));
  }, []);

  return (
    <div
      style={{
        position: 'absolute',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 8,
        paddingBlock: 8,
        paddingInline: 14,
        gap: 10,
        backgroundColor: APP.textDark,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.2s ease',
        zIndex: 10,
        whiteSpace: 'nowrap',
      }}
    >
      {/* Green check */}
      <svg width={14} height={14} viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
        <circle cx="7" cy="7" r="7" fill={APP.textReviewAccepted} />
        <polyline
          points="4,7 6,9.5 10,4.5"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>

      {/* Message */}
      <span style={{ fontSize: 12, fontWeight: 400, color: '#F5F2EC', lineHeight: '16px', fontFamily: F }}>
        §{sectionRef} {action}
      </span>

      {/* Undo button */}
      <button
        type="button"
        onClick={onUndo}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          fontSize: 12,
          fontWeight: 500,
          color: APP.textReviewPriorityHigh,
          lineHeight: '16px',
          fontFamily: F,
        }}
      >
        Undo
      </button>
    </div>
  );
}
